import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function showApproveFraudReviewDialog(fraudId: string): RootActionTypes {
  return standardAction(ActionTypes.SHOW_APPROVE_FRAUD_REVIEW_DIALOG, { show: true, fraudId });
}
